<section *ngIf="tabIndex == 0">
  <div class="d-flex flex-column h-100" id="skuIdInfoMainDiv">
    <div class="data_header_title" id="dataHeaderTitle">
      <div class="left_side_section" id="leftSideSectionSKU">
    <div class="sku_id_info_header" id="skuIdInfoHeader">
      <div class="d-flex align-items-center" id="skuAlignItemsCenter">
        <img class="sku_id_info_icon" alt="SKU Id Info icon" />
        <span i18n="@@sku-ids.label.sku-info-nav">SKU Info</span>
      </div>
    </div>
      </div>
     <!--For II-3942 Story--> 
    <div class="sku-search-input" id="skuSearchInput" [ngClass]="displayskuGroups?.length || searchSku ? 'existing_skulist_show': 'existing_skulist_hide'">
      <span class="input-group">
        <input type="search" #searchValue class="form-control input" [(ngModel)]="skuSearchData"
          (keyup.enter)="searchSkuOnEnter(skuSearchData)" placeholder={{searchPlaceholder}} maxlength="75"
          (ngModelChange)="clearSearch(skuSearchData)" />
        <div ngbDropdown class="btn-group" id="sizeDropDwonBtnGrp">
          <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="sizeDropDown"
            aria-haspopup="true" aria-expanded="false">
            {{ valueForSkuSearch }}
          </button>
          <div ngbDropdownMenu aria-labelledby="sizeDropDown" id="dropDownSkuDeleteBtnTxt" [ngClass]="isPolish ? 'leftPad':''">
            <a ngbDropdownItem selected="selected" *ngIf="valueForSkuSearch!=globConst.SKU_CODE"
              (click)="onSelectChange('1')" id="skuid"><span>{{skuCodeVal}}</span></a>
            <a ngbDropdownItem *ngIf="valueForSkuSearch!=globConst.INTERNAL_NAME" (click)="onSelectChange('2')"
              id="internalname"><span>{{this.assetLibraryConst.INTERNAL_NAME_PLACEHOLDER}}</span></a>
          </div>
        </div>
      </span>
    </div>
  </div>
  <div class="empty_screen_msg" *ngIf="!displayskuGroups?.length && searchSku" id="emptyScrenMsgNoRecord">
    <span *ngIf='!isLoading && isSKUListEmpty else loading' i18n="@@active-users.expand.no-records-found">No Records
      Found</span>
    <ng-template #loading>
      <div class="text-center">{{globConst.LOADING}}</div>
    </ng-template>
  </div>
    <div class="empty_screen_msg" [ngClass]="isSKUListEmpty && !searchSku ? 'existing_skulist_show': 'existing_skulist_hide'" id="isSKUListEmpty">
      <div id="noSKUInfoAvail" i18n="@@sku-id-info.desc.no-new-skus">There is no SKU information available, please create new.</div>
      <div class="emptyScreen_button" id="emptyScrnBtn">
        <button type="button" class="btn btn-primary btn-lg left_icon_btn addButton" (click)="createNewSKU()">
          <img class="create_new_sku_icon" alt="Create New SKU icon">&nbsp;<span i18n="@@sku-id-info.text.create-new-sku">Create New SKU</span>
        </button>
      </div>
    </div>

    <div [ngClass]="!isSKUListEmpty ? 'existing_skulist_show': 'existing_skulist_hide'" id="skuInfoListBtns">
      <!-- Data header with info like no. of sku-info, action buttons and filters -->
      <div class="data_header" *ngIf="displayskuGroups?.length" id="dataHeaderSKUDisplay">
        <ng-container>
          <span *ngIf="displayskuGroups?.length">
            <span *ngIf="displayskuGroups && displayskuGroups.length == 1" id="dataTitle" i18n="@@sku-id-info.text.sku-length-text">{{displayskuGroups.length}} SKU</span>
            <span *ngIf="displayskuGroups && displayskuGroups.length > 1" id="dataTitle" i18n="@@sku-id-info.text.skus-length-text">{{displayskuGroups.length}} SKUs</span>
            <span *ngIf="displayskuGroups.length > 1 ">
              <span class="sort-by-label" i18n="@@promo-content.sort-by">Sort by</span>:&nbsp;
              <div ngbDropdown class="btn-group" id="sortDropDownBtn">
                <button ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle" id="sortDropDown">{{sortValue}}</button>
                <div class="sort-dropdown" ngbDropdownMenu aria-labelledby="sortDropDown" id="sortDropDownBtnsName">
                  <button ngbDropdownItem *ngIf="sortValue!=createdDateVal" (click)="sortByDate()"><span>{{createdDateVal}}</span></button>
                  <button ngbDropdownItem *ngIf="sortValue!=skuCodeVal" (click)="sortByName()"><span>{{skuCodeVal}}</span></button>
                </div>
              </div>
            </span>
          </span>
        </ng-container>
        <span class="data_action" *ngIf="displayskuGroups?.length">
          <!-- Header Buttons -->
          <button *ngIf="!skuDeleteEnable" class="btn btn-outline-primary btn-sm" (click) ="multiDeleteSku()"><img class="delete-img" alt="Delete"/>&nbsp;<span i18n="@@sku-id-info.text.dele-mult-skus">Delete Multiple SKUs</span></button>
          <button *ngIf="skuDeleteEnable" (click)="resetSkuDelete()" class="btn btn-outline-primary btn-sm"><span i18n="@@delete-popup.cancel">Cancel</span></button>

          <button *ngIf="skuDeleteEnable" [disabled]="noSkuSelected" id="delete-sku-id" (click)="deleteSeletedSku()" class="btn btn-outline-primary btn-sm"><img class="delete-img" alt="Delete"/><span>{{globConst.DEL_SELECTED}}</span></button>
          <button *ngIf="!skuDeleteEnable" type="button" id="uploadSku" class="btn btn-primary btn-sm left_icon_btn" (click)="createNewSKU()">
            <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
            <span i18n="@@sku-id-info.text.create-new-sku">Create New SKU</span>
          </button>
          <!-- Pop Ups for delete and Ack -->
          <iposcen-delete-popup #deleteModalSkus [isSkuIdAll]="true" [tabbIndex]="tabbIndex" [deleteSelectedSku]="deleteSelectedSku"
          [buttonName]="(tabbIndex.length > 1) ? skuIDsButtonText : skuIDButtonText" (delete)="deleteSKUIdsContent(skusToDelete)"> 
          </iposcen-delete-popup>
          <iposcen-delete-acknowledgement-dialog #deleteAckModalSkus [isMultiSkuDelete]="true"  [tabbIndex]="tabbIndex" [deleteSelectedSkuText]="deleteSelectedSkuText"
          [sourceString]="deleteAckSkusText">
          </iposcen-delete-acknowledgement-dialog>

        </span>
      </div>
      <!-- Data Content -->
      <div *ngIf="displayskuGroups?.length > 0" id="dataContentAcc">
        <div class="accordion" id="logoContentAccordian">
          <!-- Group 1 -->
          <div class="card"
            *ngFor="let skuInfo of displayskuGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; index as i" id="skuInfoPageSize">
            <div class="card-header small_text" id="segmentOne">
              <!-- Check boxes for delete -->
              <div *ngIf="skuDeleteEnable" class="check-sku" id="checkSkuDeleteEnable">
                <div class="form-check pl-0" id="findCheckedSKUInfo">
                  <input type="checkbox" (click)="checkSkuId($event,skuInfo.skuID)" [checked]="findChecked(skuInfo.skuID)"/>
                </div>
              </div>
              <div class="card-header-content" id="cardHeaderContent">
                <div class="title_left" id="titleLeftDiv">
                  <div class="d-flex" id="publishedNameDFlex">
                    <div class="title" id="publishedTitleName">
                      <span>{{skuInfo?.publishedName}}</span>
                    </div>
                  </div>
    
                  <div class="d-flex" id="btnGTMEditDeleteSegmnt">
                    <button type="button" placement="bottom" ngbTooltip={{tooltipEdit}} class="btn gtmEditSegment"
                      (click)="editSKUIdContent(skuInfo?.skuID)">
                      <img alt="Edit" />
                    </button>
                    <button type="button" placement="bottom" ngbTooltip={{tooltipDelete}} class="btn gtmDeleteSegment"
                      (click)="openDeletePopup(skuInfo?.skuID)">
                      <img alt="Delete" />
                    </button>
                    <iposcen-delete-popup #deleteModal [contentName]="skuIDToDeleteName" [isSkuIdContent]="true"
                      [buttonName]="skuIDButtonText" (delete)="deleteSKUIdContent(skuIDToDelete)">
                    </iposcen-delete-popup>
                    <iposcen-delete-acknowledgement-dialog #deleteAckModal [sourceString]="skuIDToDeleteName">
                    </iposcen-delete-acknowledgement-dialog>
                  </div>
                </div>
                <div class="other_data" id="otherDataSKUIdInfo">
                  <div id="otherDataSKUIdInfo">
                    <div class="subtitle_group" id="subTitleGrp">
                      <span class="subtitle" *ngIf="!isSrtUser">
                        <span i18n="@@promo-content.created-by-user-name">Created By</span>:
                        {{skuInfo?.createdByUser}}
                      </span>
                      <span class="subtitle"><span i18n="@@promo-content.last-edited-by-user-name">Last Edited
                          By</span>
                        {{skuInfo?.createdByUser}}:
                        {{skuInfo?.updatedTime | dateFormat: "changeToLocalTimeZone"}}</span>
    
                      <span *ngIf="skuInfo?.internalName" class="subtitle"><span>{{internalName}}:</span>
                        {{skuInfo?.internalName}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="collapse_link collapsed collapse-button {{skuInfo?.skuID}}" type="button"
                (click)="getDetailsOfSkuID(skuInfo?.skuID)" [ngClass]="skuInfo.isExpanded ? 'transform-180' : ''" id="getDetailsOfSKUID">
                <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                </svg>
              </div>
            </div>
            <div id="collapseThree" [class.align-preview-position] ="skuDeleteEnable" class="collapse" #collapse="ngbCollapse" [(ngbCollapse)]="!skuInfo.isExpanded"
              aria-labelledby="logoCGThree" data-parent="#logoContentAccordian">
              <div class="card-body card-body-asset" id="collapseThreeCardBody">
                <div class="preview_section" id="collapse3PreviewSec">
                  <div class="col-3 preview_border" *ngIf="!isPriceSuppressionEnabled && !isSrtUser" id="collapse3PreviewBorder">
                    <label for="primaryPrice" class="mb-0">
                      <span i18n="@@create-sku-id-info.label.enter-prmary-price">Primary Price</span>
                    </label>
                    <div id="skuListPrimaryPrice">{{skuInfo?.skuList?.primaryPrice}}</div>
                    <div class="mt-4" id="skuInfoPrimaryPrice">
                      <label for="primaryPrice" class="mb-0">
                        <span i18n="@@create-sku-id-info.label.enter-secondary-price">Secondary Price</span>
                      </label>
                      <div id="skuListSecondaryPrice">{{skuInfo?.skuList?.secondaryPrice}}</div>
                    </div>
                    <div class="mt-4" id="priceStrikeThrough">
                      <label for="primaryPrice" class="mb-0">
                        <span i18n="@@sku-id-info.label.price-strickethrough">Price Strikethrough</span>
                      </label>
                      <div id="skuListPriceStrike">{{skuInfo?.skuList?.priceStrikethrough === globConst.T_TEXT ? true : false}}</div>
                    </div>
                  </div>
                  <div class="col-3 preview_border" id="col3PreviewBrdr" *ngIf="!isSrtUser">
                    <label for="primaryPrice" class="mb-0">
                      <span>{{batteryLifeText}}</span>
                    </label>
                    <div *ngIf="skuInfo?.skuList?.batteryLife !== ''" id="batterLifeNotEqual">{{skuInfo?.skuList?.batteryLife}} Hours</div>
                    <div *ngIf="skuInfo?.skuList?.batteryLife === ''" id="batteryLifeEqual">{{skuInfo?.skuList?.batteryLife}}</div>
                    <div class="mt-4" id="primaryPriceSegmntName">
                      <label for="primaryPrice" class="mb-0">
                        <span i18n="@@sku-id-info.label.segment-name">Segment Name</span>
                      </label>
                      <div id="skuListSegmntId">{{skuInfo?.skuList?.segmentID}}</div>
                    </div>
                    <div *ngIf="isCustomTileEnabled" class="mt-4" id="customMainTileEnabled">
                      <label for="primaryPrice" class="mb-0">
                        <span i18n="@@sku-id-info.label.cust-main-tile-name">Custom Main Tile</span>
                      </label>
                      <div id="customHeroTile">{{skuInfo?.skuList?.customHeroTile}}</div>
                    </div>
                  </div>
                  <div class="col-3" id="promoContent1"  *ngIf="!isSrtUser">
                    <label for="primaryPrice" class="mb-0">
                      <span i18n="@@sku-id-info.label.promo1">Promo Content 1</span>
                    </label>
                    <div id="PromotionalContentID0">{{skuInfo?.skuList?.promotionalContentIDs[0]}}</div>
                    <div class="mt-4" id="promoContent2">
                      <label for="primaryPrice" class="mb-0">
                        <span i18n="@@sku-id-info.label.promo2">Promo Content 2</span>
                      </label>
                      <div id="PromotionalContentID1">{{skuInfo?.skuList?.promotionalContentIDs[1]}}</div>
                    </div>
                    <div class="mt-4" id="promoContent3">
                      <label for="primaryPrice" class="mb-0">
                        <span i18n="@@sku-id-info.label.promo3">Promo Content 3</span>
                      </label>
                      <div>{{skuInfo?.skuList?.promotionalContentIDs[2]}}</div>
                    </div>
                  </div>
                  <div class="col-3 preview_border" *ngIf="isSrtUser">
                    <div class="mt-4" id="srtDeviceName">
                      <label for="srtDeviceName" class="mb-0">
                        <span>Device Name</span>
                      </label>
                      <div id="skusrtdevicename">{{skuInfo?.skuList?.srtDeviceName}}</div>
                    </div>
                  </div>
                  <div class="col-3 preview_border" *ngIf="isSrtUser">
                    <div class="mt-4" id="srtBrandName">
                      <label for="srtDeviceName" class="mb-0">
                        <span>Brand</span>
                      </label>
                      <div id="skusrtbrandname">{{skuInfo?.skuList?.srtBrand}}</div>
                    </div>
                  </div>
                  <div class="col-3 preview_border" *ngIf="isSrtUser">
                    <div class="mt-4" id="srtProcessor">
                      <label for="srtProcessor" class="mb-0">
                        <span>Form Factor</span>
                      </label>
                      <div id="skusrtprocessor">{{skuInfo?.skuList?.srtDeviceType}}</div>
                    </div>
                  </div>
                  <div class="col-3 preview_border" *ngIf="isSrtUser">
                    <div class="mt-4" id="srtProcessor">
                      <label for="srtProcessor" class="mb-0">
                        <span>Processor</span>
                      </label>
                      <div id="skusrtprocessor">{{skuInfo?.skuList?.srtProcessor}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Data Footer - Pagination -->
      <div class="data_footer" id="dataFooterPagination">
        <nav aria-label="promo content pagination" *ngIf="displayskuGroups && displayskuGroups?.length">
          <ngb-pagination [collectionSize]="displayskuGroups.length" [(page)]="page" [pageSize]="pageSize" [rotate]="true"
            [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
        </nav>
      </div>
    </div>
  </div>
</section>

<section *ngIf="tabIndex == 1">
  <iposcen-create-sku-id-info (gobackToSkuIdInfoParent)="setParentConfig($event)"></iposcen-create-sku-id-info>
</section>

<iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true"></iposcen-spinner-overlay>
<iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false"></iposcen-spinner-overlay>